import { render, staticRenderFns } from "./base.vue?vue&type=template&id=67b1f89a"
import script from "./base.vue?vue&type=script&lang=ts"
export * from "./base.vue?vue&type=script&lang=ts"
import style0 from "./base.vue?vue&type=style&index=0&id=67b1f89a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports